import React, { useEffect, useState } from "react";
import { ModalBody } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import { useFormik } from "formik";
import * as Yup from "yup";
import CloudStorage from "../../../../../CloudStorage/CloudStorage";
import {
  getTeamFilesFolderList,
  postFileforTeam,
  postFolderforTeam,
  postTeam,
} from "../../../../../redux/team/action";
import FileUpload1 from "./FileUpload1";
import LoginLoaderButton from "../../../../Common/Loader/LoginLoaderButton";
import AllFilesUpload from "./AllFilesUpload";

const validationSchema = Yup.object().shape({
  files: Yup.array()
    .min(1, "At least one file is required")
    .required("Files are required"),
});

export default function TeamsAddFilesModel({
  setfileModel,
  teamoverview,
  foldervalues,
}) {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState(null);
  const [work_sample, setWork_sample] = useState(null);
  const dispatch = useDispatch();

  const formik = useFormik({
    initialValues: {
      files: "",
    },
    validationSchema,
    onSubmit: (values) => {
      setLoading(true);

      const data = {
        type: 6,
        user_id: teamoverview?.company_id,
        team_folder_id: foldervalues?.id,
        files: values.files,
      };
      dispatch(postFileforTeam(data));
      setfileModel((state) => !state);
      setLoading(false);
    },
  });

  useEffect(() => {
    if (formData) {
      formik.setValues(formData);
    }
  }, [formData]);

  // useEffect(() => {
  //     dispatch(getTeamFilesFolderList());
  // }, [dispatch]);

  useEffect(() => {
    if (work_sample) {
      formik.setFieldValue("files", work_sample);
    }
  }, [work_sample, work_sample?.files]);

  useEffect(() => {
    setWork_sample(work_sample);
  }, [work_sample]);

  return (
    <>
      <div className="add-task">
        <h6>Add Files</h6>
        <button
          onClick={() => setfileModel((state) => !state)}
          className="btn close-button"
        >
          <img
            src={`${CloudStorage.cloudurl}/Assets/Images/common/close-icon.svg`}
            alt=""
          />
        </button>
      </div>
      <ModalBody>
        <div>
          <div className="">
            <form onSubmit={formik.handleSubmit}>
              <div className="form-group">
                {/* <FileUpload1
                  setWork_sample={setWork_sample}
                  selectedfiles={work_sample?.files}
                /> */}
                <AllFilesUpload 
                 setWork_sample={setWork_sample}
                 selectedfiles={work_sample?.files}
                 worksampleFiles={work_sample}
                />
                {formik.touched.files && formik.errors.files && (
                  <div style={{ color: "red" }}>{formik.errors.files}</div>
                )}
              </div>
            </form>
          </div>
        </div>
      </ModalBody>
      <div className="modal-footer mt-3">
        <button
          className="btn "
          onClick={() => formik.handleSubmit()}
          disabled={loading}
        >
          {loading ? <LoginLoaderButton /> : "Save"}
        </button>
      </div>
    </>
  );
}
